import { Consultant } from './../../../models/Consultant.model';
import { ResponsibleFinancial } from './../../../models/project/ResponsibleFinancial.model';
import { CompanyGroupsFinancial } from './../../../models/project/CompanyGroupsFinancial.model';
import { CompanyFinancial } from './../../../models/project/CompanyFinancial.model';
import { CommonHelper } from './../../../shared/helpers/CommonHelper';
import { DropDownList } from './../../../models/DropDownList.model';
import { ToastsManager } from 'ng2-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProjectFinancial } from './../../../models/project/ProjectFinancial.model';
import { TeamGroups } from './../../../models/teamGroups.model';
import { ProjectFinancialService } from './../../../services/projectFinancial.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Project } from '../../../models/Project.model';
import { AwsService } from '../../../services/aws.service';
import { CompaniesService } from '../../../services/companies.service';
import { DropdownItemFactory } from '../../../shared/factories/dropdown/dropdown-item.factory';
import { SubDivision } from '../../../models/SubDivision.model';
import { ExcellenceCentersService } from '../../../services/excellenceCenters.service';
import { ExcellenceCenter } from '../../../models/ExcellenceCenter.model';
import { IDropDown } from '../../../models/project/interface/DropDown.interface';
import { FilterBuilder } from '../../../shared/builders/filter.builder';
import { filterSelectByArrays } from "../../../shared/helpers/filter-select-items";

@Component({
  selector: 'app-project-edit',
  templateUrl: './project-edit.component.html',
  styleUrls: ['./project-edit.component.css']
})
export class ProjectEditComponent implements OnInit {
    editProjectCheck: boolean = false;
    loading: boolean = false;
    active: boolean = true;
    projectForm: FormGroup;
    fileList;
    selectedFiles:FileList;
    id;
    downloadUrl:string = '';

    teamGroups: TeamGroups[] = new Array<TeamGroups>();
    dropDownTeamGroups: any;
    consultantGroup: any;

    dropDownListDivisions: DropDownList[] = new Array<DropDownList>();
    selectedDivisionsItems: DropDownList[] = new Array<DropDownList>();
    dropDownDivisionsSettings = {};
    commonHelper: CommonHelper = new CommonHelper();

    dropDownSubDivisions: DropDownList[] = new Array<DropDownList>();
    selectedSubDivisionItems: DropDownList[] = new Array<DropDownList>();
    dropDownSubDivisionsSettings = {};
    subDivisions: SubDivision = new SubDivision();
    allSubDivisions: any = [];
    subDivisionsPerDivision: any = [];

    project: ProjectFinancial = new ProjectFinancial();

    companies: CompanyFinancial[] = new Array<CompanyFinancial>();
    responsibles: ResponsibleFinancial[] = new Array<ResponsibleFinancial>();
    companyGroups: CompanyGroupsFinancial[] = new Array<CompanyGroupsFinancial>();
    projectsHashTrack: Project[] = new Array<Project>();
    consultantsLoad: Consultant[] = new Array<Consultant>();

    dropDownClient: any;
    dropDownProjectshash: any;
    dropDownResponsable: any;
    dropDownConsultant: any;
    dropDownGroup: any;
    consultantsListAux: {id: string, itemName: string}[] = [];

    excellenceCenters: ExcellenceCenter[] = [];
    dropDownExcellenceCenters: IDropDown;

    constructor(
        private projectFinancialService: ProjectFinancialService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        public toastr: ToastsManager,
        private awsService:AwsService,
        private companiesService:CompaniesService,
        private filterBuilder: FilterBuilder,
        private excellenceCenterService: ExcellenceCentersService,
    ) { }

  async ngOnInit() {
    this.projectForm = this.formBuilder.group({
        name: [null, Validators.required]
      });
    this.loading = true;
    var idProject= this.route.snapshot.params['id'];
    this.project = await this.projectFinancialService.getById(idProject);
    this.sortConsultant();
    this.id = this.route.snapshot.params['id'];

    this.populateCompanyGroups();
    this.populateCompanies();
    this.populateResponsables();
    this.populateProjectsHashTrack(idProject);
    this.populateConsultants();
    this.populateExcellenceCenters(),

    await this.populateTeamGroups(),
    await this.populateSubDivisions();

    await this.getS3Files();
    if(this.fileList.length > 0){
      this.download(this.fileList[0].Key);
    }
    if(this.project.company._id)
      this.checkForExternalReference();
  }

  populateCompanyGroups() {
    this.projectFinancialService.getAllCompanyGroups().then(async(res) => {
      this.companyGroups = res;
      this.dropDownGroup = await this.projectFinancialService.createPropertyObjDropDown(this.companyGroups, true, "Grupos", "grupos");
      if(this.dropDownGroup.dropDownList && this.dropDownGroup.dropDownList.length > 0){
        let companyGroup = this.dropDownGroup.dropDownList.find(fnd => fnd.id == this.project.companyGroup._id);
        if(companyGroup)
          this.dropDownGroup.selectedItems.push(companyGroup);
      }
      this.closeLoad();
    });
  }

  populateCompanies() {
    let hasGroup = (this.dropDownGroup && this.dropDownGroup.selectedItems.length > 0) ? this.dropDownGroup.selectedItems[0].id : false;
    this.projectFinancialService.getAllCompany(hasGroup).then(async (res) => {//
      this.companies = res;
      this.dropDownClient = await this.projectFinancialService.createPropertyObjDropDown(this.companies, true, "Cliente", "clientes",['group'],'group');
      if(this.dropDownClient.dropDownList && this.dropDownClient.dropDownList.length > 0){
        let company = this.dropDownClient.dropDownList.find(fnd => fnd.id == this.project.company._id);
        if(company)
          this.dropDownClient.selectedItems.push(company);
      }

      this.dropDownClient.dropDownList.forEach(item => item.group =  this.commonHelper.transcriptDivisionGroup(item.group));
      this.closeLoad();
    });
  }

  async populateExcellenceCenters() {
    const excellenceCenters = await this.excellenceCenterService.getAll();
    this.excellenceCenters = excellenceCenters.filter((c: ExcellenceCenter) => Number(c.type) == 1);
    this.dropDownExcellenceCenters = this.projectFinancialService.createPropertyObjDropDown(this.excellenceCenters, false, 'Centros', 'centros');
    if (!!this.project.excellenceCenters.length) {
        this.dropDownExcellenceCenters.selectedItems = this.project.excellenceCenters.map((ec: {_id: string, name: string}) => {
            return {
                id: ec._id,
                itemName: ec.name
            } as DropDownList
        })
    }
}

    populateResponsables() {
        this.projectFinancialService.getAllResponsable().then(async (res) => {
            this.responsibles = res;
            this.dropDownResponsable = await this.projectFinancialService.createPropertyObjDropDown(this.responsibles, true, "Responsável", "responsáveis");
            this.dropDownResponsable.selectedItems.push(this.dropDownResponsable.dropDownList
            .find(fnd => fnd.id == this.project.userResponsable._id));
            this.closeLoad();
        });
    }

  async getS3Files(){
    this.fileList = await this.awsService.getFiles(this.project._id);
  };

  selectFile(event) {
      this.selectedFiles = event.target.files;
  }

  async deleteFile(name){
    await this.awsService.deleteFile(name);
    await this.getS3Files();
  }

   async upload(id) {
     try {
        let length = this.selectedFiles.length;
        for(let i=0; i<length; i++){
          const file = this.selectedFiles.item(i);
            await this.awsService.uploadfile(file,id);
        }

        await this.getS3Files();
        this.onChange();
     } catch (error) {
       console.log(error);
     }
  }

    async populateProjectsHashTrack(id) {
        if (id == '') {
            await this.projectFinancialService.getAllProject().then((res) => {
                this.projectsHashTrack = res;
                this.populateDropHash();
            });
        } else {
            await this.projectFinancialService.getAllProjectEdit(id).then((res) => {
                this.projectsHashTrack = res;
                this.populateDropHash();
            });
        }
    }

    async populateDropHash() {
        this.dropDownProjectshash = await this.projectFinancialService.createPropertyObjDropDown(this.projectsHashTrack, false, "Projetos", "projetos");
        var projetos = await this.dropDownProjectshash.dropDownList.filter(flt => this.project.hashTrack.find(fnd => fnd._id == flt.id) != null);
        projetos.forEach(element => {
            this.dropDownProjectshash.selectedItems.push(element);
        });
        this.closeLoad();
    }

    populateConsultants() {
        this.projectFinancialService.getAllConsultants().then(async (res) => {
            this.consultantsLoad = res;
            this.dropDownConsultant = await this.projectFinancialService.createPropertyObjDropDown(this.consultantsLoad, false, "Consultores", "consultores");
            this.consultantsListAux = [...this.dropDownConsultant.dropDownList];
            this.closeLoad();
        });
    }

    async populateTeamGroups() {
        this.teamGroups = await this.projectFinancialService.getAllTeamGroups();
        this.dropDownTeamGroups = await this.projectFinancialService.createPropertyObjDropDown(this.teamGroups, false, "Grupos de Times", "Grupos de Times");
        let teamGroupOfProject = await this.dropDownTeamGroups.dropDownList.filter(flt => this.project.teamGroups.find(fnd => fnd._id == flt.id) != null);
        teamGroupOfProject.forEach(element => {
          this.dropDownTeamGroups.selectedItems.push(element);
        });

        this.closeLoad();
    }

    async populateSubDivisions() {
        this.dropDownSubDivisionsSettings = this.commonHelper.getDropDownSettings(true, 'Tipo de Serviço', false, 'Marcar todos os Tipos de Serviços', 'Desmarcar todos os Tipos de Serviços', true,null, '');
        this.allSubDivisions = await this.projectFinancialService.getAllSubDivisions();
        this.allSubDivisions = await this.filterBuilder.buildSubDivisionFilter();
        this.dropDownSubDivisions = this.allSubDivisions;        if(this.project.subDivision) {
            const subDivisionProject = this.dropDownSubDivisions.find(sub => sub.id === this.project.subDivision.code);
            if(subDivisionProject) {
                this.selectedSubDivisionItems = [{
                    id: subDivisionProject.id,
                    itemName: subDivisionProject.itemName
                }];
                this.subDivisions.code = subDivisionProject.id;
                this.subDivisions.name = subDivisionProject.itemName;
            }
        }
        this.closeLoad();
    }

    closeLoad() {
        if ( this.companies.length > 0 && this.responsibles.length > 0
            && this.projectsHashTrack.length > 0  && this.consultantsLoad.length > 0) {
            this.loading = false;
            this.onChange();
        }
    }

  onSubDivisionChange() {
    if(this.selectedSubDivisionItems.length > 0){
      let selectedSubDivision =  this.subDivisionsPerDivision.find(sub => sub.code == this.selectedSubDivisionItems[0].id)
      this.subDivisions.code = this.selectedSubDivisionItems[0].id;
      this.subDivisions.name = this.selectedSubDivisionItems[0].itemName;
      this.subDivisions.sapSubDivision = selectedSubDivision.sapSubDivision


    } else {
      this.subDivisions = new SubDivision();
    }
  }

  onChange() {
      if (!this.loading) {
        if (this.dropDownResponsable.selectedItems.length > 0
            && this.selectedDivisionsItems.length > 0
            && this.dropDownClient.selectedItems.length > 0
            && this.projectForm.valid) {
                this.editProjectCheck = true;
            } else {
                this.editProjectCheck = false;
            }
        }
   }

   clearCustomer(){
      this.dropDownClient.selectedItems = [];
      this.populateCompanies();
    }

   async edit() {
    if(this.dropDownClient.selectedItems.length > 0)
      this.project.company = this.companies.find(fnd => fnd._id == this.dropDownClient.selectedItems[0].id);

    this.project.companyGroup = this.companyGroups.find(fnd => fnd._id == this.dropDownGroup.selectedItems[0].id);
    this.project.userResponsable = this.responsibles.find(fnd => fnd._id == this.dropDownResponsable.selectedItems[0].id);
    this.project.hashTrack = this.projectsHashTrack
          .filter(flt => this.dropDownProjectshash.selectedItems.find(fnd => fnd.id == flt._id) != null);

    if(this.dropDownTeamGroups.selectedItems.length > 0)
        this.project.teamGroups = this.dropDownTeamGroups.selectedItems.map(teamGroup => ({ _id: teamGroup.id, name: teamGroup.itemName }));

    if (!this.dropDownExcellenceCenters.selectedItems.length) {
      this.toastr.warning('Selecione um ou mais Centros de Excelência para prosseguir com a criação do Projeto', 'Projeto');
      return;
    }

    try {
      if(this.project.name.length > 30)
        return this.toastr.warning('O nome do projeto é longo demais, permitido apenas 30 caracteres!');

        this.loading = true;
      let response = await this.projectFinancialService.update(this.project);
      if(response._id){
        this.loading = false;
        this.router.navigate(['/projects']);
        this.toastr.success('Projeto alterado com sucesso!');
      } else {
        this.loading = false;
        this.toastr.warning(response.message);
      }
    } catch(err) {
      this.loading = false;
      this.toastr.warning('Erro Salvar Projeto!')
    }
   }

   OnCancel() {
    this.router.navigate(['/projects']);
   }

   verifyValidTouched(fieldName) {
    return !this.projectForm.get(fieldName).valid && this.projectForm.get(fieldName).touched;
  }

  applyErrorCss(fieldName) {
    return {
      'has-error': this.verifyValidTouched(fieldName)
    }
  }

  async download(name){
    this.downloadUrl = await this.awsService.download(name);
  }

  addItem() {
    if(this.dropDownConsultant.selectedItems.length > 0 ) {
      const selectedConsultant = this.dropDownConsultant.selectedItems[0];
      const consultant = new Consultant();
      consultant._id = selectedConsultant.id;
      consultant.name = selectedConsultant.itemName;

      this.addConsultant(consultant);
      this.toastr.info(`O consultor "${consultant.name}" foi adicionado ao projeto!`, "Novo consultor")

      this.dropDownConsultant.selectedItems = [];
    }
  }

  addConsultant(consultant: Consultant) {
    let existsConsultant =  this.project.consultants.findIndex(item => item._id == consultant._id);
    if( existsConsultant === -1 ){
      let newConsultant = this.consultantsLoad.find(c => c._id == consultant._id);
      if(newConsultant) {
        consultant.fcEmail = newConsultant.fcEmail;
        consultant.sapCardCode = newConsultant.sapCardCode;
        consultant.hashTrackId = newConsultant.hashTrackId;
        this.project.consultants.push(consultant);
        this.refreshConsultantSelect();
      }
    }

    this.onChange();
    this.sortConsultant();
  }

  sortConsultant() {
    this.project.consultants.sort((a, b) => {
        if(a.name > b.name) return 1;
        if(a.name < b.name) return -1;
        return 0;
    })
  }

  addItemGroup() {
    if(this.dropDownTeamGroups.selectedItems.length > 0) {

      let teamGroupsConsultants = [];
      const teamGroupsIds = this.dropDownTeamGroups.selectedItems.map(t => t.id);
      teamGroupsIds.forEach(tgId => {
        const teamGroup = this.teamGroups.find(t => t._id === tgId);
        teamGroupsConsultants = [...teamGroupsConsultants, ...teamGroup.consultants];
      });

      teamGroupsConsultants.forEach(c => {
        const consultant = new Consultant();
        consultant._id = c._id;
        consultant.name = c.name;

        this.addConsultant(consultant);
      });
      const [teamGroupName] = this.dropDownTeamGroups.selectedItems;
      this.toastr.info(`O Grupo "${teamGroupName.itemName}" foi adicionado no projeto!`, "Novo consultor")
    }
  }

  refreshConsultantSelect = () => {
    const teamGroupIds = this.project.consultants.map((cons) => cons._id);
    this.dropDownConsultant.dropDownList = filterSelectByArrays(this.consultantsListAux, teamGroupIds);
  }

  removeItem(i) {
    const consultantName =  this.project.consultants[i].name || "";
    let consultant = this.project.consultants[i];
    let indexConsulntant = this.dropDownConsultant.selectedItems.findIndex((consultantDeopDown) => consultantDeopDown.id == consultant._id);
    if(indexConsulntant != -1)
      this.dropDownConsultant.selectedItems.splice(indexConsulntant, 1);

    this.project.consultants.splice(i, 1);
    this.refreshConsultantSelect();
    this.toastr.info(`O consultor "${consultantName}" foi removido do projeto!`);
  }

  async checkForExternalReference(){
    let _id = this.project.company._id.toString()
    let company = await this.companiesService.getById(_id);
    if(company){
      if(!company.externalReference){
        this.toastr.onClickToast()
                    .subscribe( toast => {
                      this.router.navigate([`/companies/companies-edit/${_id}`]);
                      this.toastr.dismissToast(toast);
                    });
                    this.toastr.error(`O cliente selecionado não possui vínculo com um cliente Hashtrack. Para vincular, clique aqui!`,'Cliente não mapeado!',{
                      toastLife:10000,
                      showCloseButton: true
                    });
      }
    }
  }

  onCenterChange() {
    if (this.dropDownExcellenceCenters.selectedItems.length) {
      const centers = this.dropDownExcellenceCenters.selectedItems.map((center: DropDownList) => {
        return {
          _id: center.id,
          name: center.itemName
        } as ExcellenceCenter
      });
      this.project.excellenceCenters = [...centers];
        return;
      }
      this.project.excellenceCenters = new Array<ExcellenceCenter>();
  }
}



// WEBPACK FOOTER //
// ./src/app/views/projects/project-edit/project-edit.component.ts